import Vue from 'vue';

export const insuranceRulesState = Vue.observable({isShortTerm: false});

export function getInsuranceSampleUrl() {
  return '/upload/osgop/obrazec_osgop.pdf';
}

export function getInsuranceRulesUrl() {
  return '/upload/rules/%D0%9F%D1%80%D0%B0%D0%B2%D0%B8%D0%BB%D0%B0%20%D0%9E%D0%A1%D0%93%D0%9E%D0%9F%20%D0%BD%D0%B0%20%D1%81%D0%B0%D0%B9%D1%82.pdf';
}
